import { FC, Fragment } from 'react';

import { P } from 'shared/components/Typography';

export interface InvalidItem {
  id: string;
  number: number;
  code: string;
  isValid: boolean;
  modifications: { modificationId: string; name: string }[];
}

interface InvalidItemsAndModificationsProps {
  items?: InvalidItem[] | null;
}

export const InvalidItemsAndModifications: FC<
  InvalidItemsAndModificationsProps
> = ({ items }) => {
  return (
    <>
      {[...(items ?? [])]
        .sort((a, b) => a.number - b.number)
        .map((item) => (
          <Fragment key={item.id}>
            {!item.isValid && (
              <P color="inherit">
                Invalid Item {item.number}: {item.code}
              </P>
            )}

            {item.modifications.map((mod) => (
              <P color="inherit" key={mod.modificationId}>
                Invalid Modification {item.number}: {mod.name}
              </P>
            ))}
          </Fragment>
        ))}
    </>
  );
};
